import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck, faCheckCircle, faShippingFast, faExclamationTriangle, faClock } from '@fortawesome/free-solid-svg-icons';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

// Register the necessary components for Bar Chart
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const MiniDashboard = ({ indicators, shipments }) => {
    // Calculate the counts for each transport type
    const transportCounts = shipments.reduce((acc, shipment) => {
        acc[shipment.trans] = (acc[shipment.trans] || 0) + 1;
        return acc;
    }, {});

    // Bar chart data
    const barData = {
        labels: ['Transport Types'],
        datasets: [
            {
                label: 'AIR',
                data: [transportCounts['AIR']],
                backgroundColor: '#007bff',
            },
            {
                label: 'ROA',
                data: [transportCounts['ROA']],
                backgroundColor: '#007bff',
            },
            {
                label: 'SEA',
                data: [transportCounts['SEA']],
                backgroundColor: '#007bff',
            },
        ],
    };

    // Bar chart options
    const barOptions = {
        responsive: true,
        scales: {
            x: {
                stacked: false,
            },
            y: {
                stacked: false,
            },
        },
        plugins: {
            legend: {
                display: false, // No legend for simplicity
            },
        },
    };


    return (
        <div className="bg-white shadow rounded-lg p-4 w-full">
            <div className="grid grid-cols-6 divide-x divide-gray-200 text-center">
                <div className="flex flex-col items-center justify-center py-1">
                    <FontAwesomeIcon icon={faTruck} className="text-blue-600 text-2xl mb-1" /> {/* Smaller icon size */}
                    <p className="text-sm text-gray-600">Total Shipments</p>
                    <p className="text-lg font-semibold text-gray-800">{indicators.totalShipments}</p>
                </div>
                <div className="flex flex-col items-center justify-center py-1">
                    <FontAwesomeIcon icon={faCheckCircle} className="text-blue-600 text-2xl mb-1" /> {/* Smaller icon size */}
                    <p className="text-sm text-gray-600">Completed Shipments</p>
                    <p className="text-lg font-semibold text-gray-800">{indicators.completedShipments}</p>
                </div>
                <div className="flex flex-col items-center justify-center py-1">
                    <FontAwesomeIcon icon={faShippingFast} className="text-blue-600 text-2xl mb-1" /> {/* Smaller icon size */}
                    <p className="text-sm text-gray-600">In-Transit Shipments</p>
                    <p className="text-lg font-semibold text-gray-800">{indicators.inTransitShipments}</p>
                </div>
                <div className="flex flex-col items-center justify-center py-1">
                    <FontAwesomeIcon icon={faClock} className="text-blue-600 text-2xl mb-1" /> {/* Smaller icon size */}
                    <p className="text-sm text-gray-600">Average Transit Time (days)</p>
                    <p className="text-lg font-semibold text-gray-800">{indicators.averageTransitTime}</p>
                </div>
                <div className="flex flex-col items-center justify-center py-1">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="text-blue-600 text-2xl mb-1" /> {/* Smaller icon size */}
                    <p className="text-sm text-gray-600">Shipments at Risk</p>
                    <p className="text-lg font-semibold text-gray-800">{indicators.shipmentsAtRisk}</p>
                </div>
                <div className="flex items-center justify-center py-4">
                    <div style={{ width: '100%', height: '100px' }}> {/* Adjust width and height as needed */}
                        <Bar data={barData} options={barOptions} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MiniDashboard;
